"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const just_kebab_case_1 = __importDefault(require("just-kebab-case"));
exports.default = just_kebab_case_1.default;
